import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";

const LINKS = [
  { label: "Services", href: "/#services" },
  { label: "Pricing", href: "/pricing" },
  { label: "Contact", href: "/contact" },
  { label: "Process", href: "/#process" },
  { label: "FAQ", href: "/faq" },
];

const Logo = () => (
  <Link to="/" data-testid="nav-logo" className="flex items-center gap-2.5">
    <img
      src="/gstudio-icon.png"
      alt="G-Studio logo"
      className="h-10 w-10 rounded-xl object-cover shadow-md shadow-blue-600/20"
    />
    <span className="font-display text-xl font-bold tracking-tight text-white">
      G-Studio<span className="text-blue-400">.</span>
    </span>
  </Link>
);

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed top-0 z-50 w-full border-b border-white/10 bg-[#050816]/80 backdrop-blur-md">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <Logo />
        <nav className="hidden items-center gap-8 lg:flex" data-testid="nav-links">
          {LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm font-semibold text-slate-400 transition-colors hover:text-blue-400"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="hidden items-center gap-3 lg:flex">
          <a
            href="tel:+15078411801"
            data-testid="nav-call-btn"
            className="group flex items-center gap-1.5 rounded-full bg-blue-600 px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-blue-700"
          >
            <Phone className="h-4 w-4" />
            (507) 841-1801
          </a>
        </div>
        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="rounded-lg p-2 text-slate-200 lg:hidden"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      {open && (
        <div className="border-t border-white/10 bg-[#070B1E] px-4 py-4 lg:hidden" data-testid="nav-mobile-menu">
          <div className="flex flex-col gap-1">
            {LINKS.map((l) => (
              <a
                key={l.label}
                href={l.href}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm font-semibold text-slate-300 hover:bg-white/5/5"
              >
                {l.label}
              </a>
            ))}
            <a
              href="tel:+15078411801"
              data-testid="nav-mobile-call-btn"
              onClick={() => setOpen(false)}
              className="mt-2 rounded-full bg-blue-600 px-5 py-3 text-center text-sm font-semibold text-white"
            >
              Call (507) 841-1801
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
